import { CmsApplianceDetailsSteppedMultiPlanPage } from '../../models/appliance-details-stepped-multi-plan/cms-appliance-details-stepped-multi-plan-page.interface';
import { mockCmsRegistrationRoot } from '../cms/cms-registration-root.mock';
import { mockCmsApplianceDetailsSteppedMultiPlanBenefitsPanel } from './cms-appliance-details-stepped-multi-plan-benefits-panel.mock';
import { mockCmsApplianceDetailsSteppedMultiPlanForm } from './cms-appliance-details-stepped-multi-plan-form.mock';

export const mockCmsApplianceDetailsSteppedMultiPlanPage: CmsApplianceDetailsSteppedMultiPlanPage =
  {
    ...mockCmsRegistrationRoot,
    ...mockCmsApplianceDetailsSteppedMultiPlanForm,
    applianceDetailsSteppedMultiPlanBenefitsPanel:
      mockCmsApplianceDetailsSteppedMultiPlanBenefitsPanel,
  };
